const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJavaScriptframeworksCuate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.37,311.22l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.06h-.44v-.45L665.39,300v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28V300c0,1.9-.08,3.79-.13,5.66Zm0,0-.14-5.65c-.05-1.86-.11-3.7-.13-5.54l.27.28c-4.41.05-8.82.16-13.24.16l-13.24.06.5-.5,0,11.19-.45-.44c2.18,0,4.36,0,6.55.05L679,311Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.6,325.33l-13.12.28-6.67.11c-2.22,0-4.46,0-6.69.06h-.44v-.45l0-11.19v-.5h.5l13.24.07c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.79-.13,5.66Zm0,0-.14-5.65c-.05-1.86-.11-3.7-.13-5.54l.27.28c-4.41.05-8.83.16-13.24.16l-13.24.06.5-.5,0,11.19-.45-.44c2.18,0,4.36,0,6.55.05l6.57.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.14,325.33l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7.06h-.44v-.45l-.06-11.19v-.5h.5l13.24.07c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.79-.13,5.66Zm0,0-.14-5.65c0-1.86-.11-3.7-.13-5.54l.27.28c-4.41.05-8.82.16-13.24.16l-13.24.06.5-.5,0,11.19-.45-.44c2.19,0,4.36,0,6.55.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.79,178.07l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7,0h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.78-.14,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.82.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,192.18l-13.12.28-6.67.11c-2.22,0-4.46,0-6.69.05h-.44v-.45L273,181v-.5h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28V181c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5L274,192.18l-.45-.45c2.18,0,4.36,0,6.55.06l6.57.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.56,192.18l-13.12.28-6.66.11c-2.23,0-4.46,0-6.7.05h-.44v-.45L302.58,181v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28V181c0,1.9-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.19,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.88,252.11l-13.12.28-6.67.11c-2.22,0-4.46,0-6.69.05H72v-.45l0-11.19v-.5h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.57.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.86,178.06l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.05h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.12,13.24.17h.28v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.65c-.05-1.87-.11-3.71-.13-5.54l.27.27c-4.41.05-8.82.16-13.24.17l-13.24.06.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.84,69.38l-13.12.28-6.67.11c-2.22,0-4.46,0-6.69.06h-.44v-.45l0-11.19v-.5h.5l13.24.06c4.41,0,8.83.12,13.24.17h.28v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.65c-.05-1.87-.11-3.71-.13-5.54l.27.27c-4.41,0-8.83.16-13.24.17l-13.24.06.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.57.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.61,83.49l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.06h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.12,13.24.17h.28v.27c0,1.9-.09,3.79-.14,5.65Zm0,0-.14-5.65c0-1.87-.11-3.71-.13-5.54l.27.27c-4.41.05-8.82.16-13.24.17l-13.24.06.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.34,69.39l-13.13.28-6.66.11c-2.22,0-4.46,0-6.69.06h-.45v-.45l0-11.19v-.5h.51l13.24.07c4.41,0,8.82.11,13.24.16h.27v.27c0,1.9-.09,3.79-.13,5.66Zm0,0-.15-5.65c0-1.86-.11-3.71-.13-5.54l.28.27c-4.42.06-8.83.16-13.24.17l-13.24.06.5-.5L43.3,69.39,42.86,69c2.18,0,4.35,0,6.54,0l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.77,
    y: 60.22,
    width: 118.54,
    height: 79.88,
    style: {
      fill: "#fff",
      stroke: "#ebebeb",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.23,66.26a2.73,2.73,0,1,1-2.73-2.73A2.73,2.73,0,0,1,111.23,66.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.37,66.26a2.73,2.73,0,1,1-2.72-2.73A2.72,2.72,0,0,1,122.37,66.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.52,66.26a2.73,2.73,0,1,1-2.73-2.73A2.73,2.73,0,0,1,133.52,66.26Z",
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.77,
    y1: 72.25,
    x2: 218.31,
    y2: 72.25,
    style: {
      fill: "none",
      stroke: "#ebebeb",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,165.58c0-1.25.17-4.58.17-6,0-6.08-2.17-8.83-7.83-9-2.66-.16-4.24-1.74-4.24-4s1.58-3.83,4.24-4c5.66-.25,7.83-2.91,7.83-9.08,0-1.41-.17-4.74-.17-6,0-8.08,3.42-13.24,16.32-16.07,2.59-.59,4.58,1,4.58,3.41a3.49,3.49,0,0,1-2.33,3.41c-8.07,2.5-9.24,5.08-9.24,10.75,0,1.66.17,4.41.17,6.16,0,6.49-3.17,9.66-8.66,11.41,5.58,1.83,8.66,4.91,8.66,11.41,0,1.74-.17,4.49-.17,6.16,0,5.66,1.17,8.24,9.24,10.74a3.49,3.49,0,0,1,2.33,3.41c0,2.42-2,4-4.58,3.42C203.42,178.91,200,173.74,200,165.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.8,127.53c0,1.25-.17,4.58-.17,6,0,6.17,2.25,8.83,7.92,9.08,2.58.17,4.16,1.75,4.16,4s-1.58,3.83-4.16,4c-5.67.17-7.92,2.92-7.92,9,0,1.41.17,4.74.17,6,0,8.16-3.41,13.33-16.32,16.16-2.58.58-4.58-1-4.58-3.42a3.45,3.45,0,0,1,2.41-3.41c8-2.5,9.16-5.08,9.16-10.74,0-1.67-.16-4.42-.16-6.16,0-6.5,3.16-9.66,8.66-11.41-5.58-1.83-8.66-4.92-8.66-11.41,0-1.75.16-4.5.16-6.16,0-5.67-1.16-8.25-9.16-10.75a3.45,3.45,0,0,1-2.41-3.41c0-2.41,2-4,4.58-3.41C245.39,114.29,248.8,119.45,248.8,127.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.2,318.6a3.39,3.39,0,0,1-2.37,5.81,3.55,3.55,0,0,1-2.47-1L292.23,308.1c-.16-.05-.21-.16-.27-.32a.91.91,0,0,0-.16-.11,1.26,1.26,0,0,1-.16-.43.27.27,0,0,1-.16-.21c-.06-.11-.06-.27-.11-.33s-.11-.21-.11-.27v-.37c0-.11-.05-.16-.05-.33s.05-.21.05-.26v-.38c0-.11.11-.16.11-.22s.05-.27.11-.43,0-.05,0-.1a3.59,3.59,0,0,1,.27-.49.11.11,0,0,1,.11-.11,1,1,0,0,1,.32-.37L307.36,288a3.51,3.51,0,0,1,4.84,0,3.42,3.42,0,0,1,0,4.84l-12.76,12.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.92,320.32l13.19-31.38a3,3,0,0,1,3.93-1.56,2.91,2.91,0,0,1,1.51,3.82l-13.19,31.44a3,3,0,0,1-2.75,1.77,2.55,2.55,0,0,1-1.07-.21A2.92,2.92,0,0,1,325.92,320.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.59,307.67s0,.06,0,.06a2.58,2.58,0,0,1-.37.37L355,323.44a3.5,3.5,0,0,1-4.84,0,3.4,3.4,0,0,1,0-4.84L363,305.73,350.2,292.87a3.4,3.4,0,0,1,0-4.84,3.51,3.51,0,0,1,4.84,0l15.13,15.34a2.58,2.58,0,0,1,.37.37s0,.11,0,.11a3.64,3.64,0,0,1,.27.49c0,.05.06.05.06.1a2.29,2.29,0,0,0,.16.49c0,.05.05.05.05.16v.38s.06.21.06.26-.06.22-.06.27v.43c0,.06-.05.06-.05.11a3.75,3.75,0,0,0-.16.49c0,.05-.06.05-.06.16S370.7,307.46,370.59,307.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.5,140.33a12.9,12.9,0,0,1-12,12.87v0H501.46A15.17,15.17,0,0,1,500,123a25.56,25.56,0,0,1,49.53-8A15.18,15.18,0,0,1,571.5,127.6a12,12,0,0,1,2.09-.17A12.91,12.91,0,0,1,586.5,140.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.58,235.48a3.72,3.72,0,0,1,3.92,0c.33.2.67.39,1,.57s.69.36,1,.53a3.74,3.74,0,0,1,2.19,3.24l.15,4.83,15.72-.49-.15-4.86a3.72,3.72,0,0,1,2-3.36,21.8,21.8,0,0,0,2-1.21,3.78,3.78,0,0,1,3.94-.27l4.24,2.28L132,222.9l-4.24-2.28a3.78,3.78,0,0,1-2-3.43,21.81,21.81,0,0,0-.07-2.29,3.73,3.73,0,0,1,1.7-3.52l4.13-2.56-8.29-13.37L119.16,198a3.66,3.66,0,0,1-3.85,0c-.34-.21-.7-.41-1.06-.61l-1.09-.55a3.69,3.69,0,0,1-2.14-3.22l-.14-4.84-15.73.49.16,4.82a3.68,3.68,0,0,1-1.91,3.35,23.52,23.52,0,0,0-2.13,1.32,3.64,3.64,0,0,1-3.84.21l-4.25-2.27-7.44,13.87L80,212.85a3.77,3.77,0,0,1,2,3.44,21.81,21.81,0,0,0,.07,2.29,3.73,3.73,0,0,1-1.71,3.52l-4.12,2.55L84.48,238Zm3.24-23.3a12.89,12.89,0,1,1,4.54,15A12.89,12.89,0,0,1,91.82,212.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.68,110.32a2.62,2.62,0,0,1,2.43-1.28l.81,0,.82,0a2.6,2.6,0,0,1,2.42,1.28l1.69,2.93,9.55-5.51-1.69-2.93a2.6,2.6,0,0,1,.1-2.75c.29-.46.57-.93.82-1.42A2.63,2.63,0,0,1,186,99.19h3.37v-11H186a2.63,2.63,0,0,1-2.33-1.45c-.25-.49-.53-1-.82-1.42a2.6,2.6,0,0,1-.1-2.75l1.69-2.93-9.55-5.51-1.7,3a2.61,2.61,0,0,1-2.42,1.27l-.81,0-.81,0a2.62,2.62,0,0,1-2.43-1.28L165,74.11l-9.55,5.51,1.69,2.92a2.62,2.62,0,0,1-.09,2.75,15.64,15.64,0,0,0-.83,1.43,2.63,2.63,0,0,1-2.33,1.45h-3.37v11h3.37a2.63,2.63,0,0,1,2.33,1.45,15.64,15.64,0,0,0,.83,1.43,2.62,2.62,0,0,1,.09,2.75l-1.69,2.92,9.55,5.51Zm-5.79-16.64a9,9,0,1,1,9,9A9,9,0,0,1,160.89,93.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.26,108.16l-5.51-9.55-2.92,1.69a2.62,2.62,0,0,1-2.75-.09,15.64,15.64,0,0,0-1.43-.83,2.63,2.63,0,0,1-1.45-2.33V93.68h-11v3.37a2.63,2.63,0,0,1-1.45,2.33,15.64,15.64,0,0,0-1.43.83,2.62,2.62,0,0,1-2.75.09l-2.92-1.69-5.51,9.55,2.94,1.69a2.62,2.62,0,0,1,1.28,2.43c0,.27,0,.54,0,.81s0,.54,0,.81a2.61,2.61,0,0,1-1.27,2.42l-3,1.7,5.51,9.55,2.93-1.69a2.62,2.62,0,0,1,2.75.1,15.38,15.38,0,0,0,1.42.82,2.63,2.63,0,0,1,1.45,2.33v3.37h11v-3.37a2.63,2.63,0,0,1,1.45-2.33,15.38,15.38,0,0,0,1.42-.82,2.62,2.62,0,0,1,2.75-.1l2.93,1.69,5.51-9.55-2.94-1.69a2.61,2.61,0,0,1-1.27-2.42c0-.27,0-.54,0-.82s0-.54,0-.81a2.62,2.62,0,0,1,1.28-2.43Zm-10.54,4.93a9,9,0,1,1-9-9A9,9,0,0,1,663.72,113.09Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screens--inject-60"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.28,
    y: 70.08,
    width: 223.81,
    height: 141.2,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.28,
    y: 70.08,
    width: 223.81,
    height: 12.44,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,76.39a3.13,3.13,0,1,1-3.13-3.13A3.13,3.13,0,0,1,427,76.39Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.73,76.39a3.13,3.13,0,1,1-3.13-3.13A3.13,3.13,0,0,1,439.73,76.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.52,76.39a3.13,3.13,0,1,1-3.13-3.13A3.13,3.13,0,0,1,452.52,76.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.62,
    y: 107.26,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.12,
    y: 107.26,
    width: 107.4,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.6,
    y: 107.26,
    width: 12.63,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 571.81,
    y: 139.76,
    width: 12.63,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 566.97,
    y: 107.26,
    width: 42.58,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.27,
    y: 113.76,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 113.76,
    width: 50.06,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.88,
    y: 139.76,
    width: 18.93,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.12,
    y: 133.26,
    width: 47.81,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 120.26,
    width: 33.54,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.04,
    y: 126.76,
    width: 33.54,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.86,
    y: 120.26,
    width: 84.68,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.12,
    y: 139.76,
    width: 105.43,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.57,
    y: 113.76,
    width: 55.4,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.8,
    y: 113.76,
    width: 63.02,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.81,
    y: 120.26,
    width: 21.53,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.27,
    y: 120.26,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.62,
    y: 126.76,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.12,
    y: 126.76,
    width: 39.3,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 146.26,
    width: 39.3,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551,
    y: 152.76,
    width: 50.62,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 489.09,
    y: 146.26,
    width: 70.53,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 482.14,
    y: 152.76,
    width: 65.43,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 152.76,
    width: 11.38,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490.63,
    y: 133.26,
    width: 73.6,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 566.97,
    y: 133.26,
    width: 47.77,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.41,
    y: 126.76,
    width: 73.54,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.62,
    y: 133.26,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.62,
    y: 139.76,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.27,
    y: 146.26,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.27,
    y: 152.76,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.62,
    y: 158.21,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.12,
    y: 158.21,
    width: 77.97,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.27,
    y: 164.71,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 164.71,
    width: 50.06,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 171.21,
    width: 33.54,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.86,
    y: 171.21,
    width: 84.68,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.57,
    y: 164.71,
    width: 55.4,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.8,
    y: 164.71,
    width: 63.02,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.27,
    y: 171.21,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.73,100.86a.58.58,0,0,1-.82.83l-2.57-2.6s0,0,0-.06l0,0a.21.21,0,0,1,0-.07.05.05,0,0,1,0,0,.11.11,0,0,1,0-.05s0,0,0,0v-.06s0,0,0-.06,0,0,0,0v-.07l0,0a.22.22,0,0,1,0-.08h0a.73.73,0,0,1,0-.09s0,0,0,0a.15.15,0,0,1,0-.07l2.57-2.6a.59.59,0,0,1,.82,0,.57.57,0,0,1,0,.82l-2.16,2.18Z",
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.05,101.16l2.24-5.32a.5.5,0,0,1,.66-.27.49.49,0,0,1,.26.65L436,101.55a.5.5,0,0,1-.46.3.37.37,0,0,1-.18,0A.49.49,0,0,1,435.05,101.16Z",
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.63,99h0l-.07.07-2.56,2.6a.59.59,0,0,1-.41.16.57.57,0,0,1-.41-.16.59.59,0,0,1,0-.83l2.16-2.18-2.16-2.18a.57.57,0,0,1,0-.82.59.59,0,0,1,.82,0l2.56,2.6.07.07a0,0,0,0,1,0,0,.79.79,0,0,0,0,.09h0a.47.47,0,0,0,0,.09s0,0,0,0v.07s0,0,0,0,0,0,0,0v.07s0,0,0,0,0,.06,0,.08,0,0,0,0A.59.59,0,0,0,442.63,99Z",
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.92,
    y: 97.3,
    width: 223.81,
    height: 141.2,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.92,
    y: 97.3,
    width: 223.81,
    height: 12.44,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.59,103.61a3.13,3.13,0,1,1-3.13-3.13A3.13,3.13,0,0,1,122.59,103.61Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.24,
    cy: 103.61,
    r: 3.13,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.16,103.61a3.14,3.14,0,1,1-3.14-3.13A3.14,3.14,0,0,1,148.16,103.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.26,
    y: 134.48,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.75,
    y: 134.48,
    width: 87.4,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.46,
    y: 134.48,
    width: 26.2,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.24,
    y: 134.48,
    width: 12.63,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.45,
    y: 166.98,
    width: 12.63,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.61,
    y: 134.48,
    width: 35.58,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.91,
    y: 140.98,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.24,
    y: 140.98,
    width: 50.06,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.52,
    y: 166.98,
    width: 18.93,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.75,
    y: 160.48,
    width: 47.81,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.24,
    y: 147.48,
    width: 33.54,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.68,
    y: 153.98,
    width: 33.54,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.5,
    y: 147.48,
    width: 64.68,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.75,
    y: 166.98,
    width: 85.43,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.2,
    y: 140.98,
    width: 48.4,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.44,
    y: 140.98,
    width: 43.02,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.6,
    y: 147.48,
    width: 14.53,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.91,
    y: 147.48,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.26,
    y: 153.98,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.75,
    y: 153.98,
    width: 39.3,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.24,
    y: 173.48,
    width: 39.3,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.44,
    y: 179.98,
    width: 43.62,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.73,
    y: 173.48,
    width: 50.53,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.58,
    y: 179.98,
    width: 45.43,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.24,
    y: 179.98,
    width: 14.77,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.29,
    y: 179.98,
    width: 11.38,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.27,
    y: 160.48,
    width: 53.6,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.61,
    y: 160.48,
    width: 40.77,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.05,
    y: 153.98,
    width: 53.54,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.26,
    y: 160.48,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.26,
    y: 166.98,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.91,
    y: 173.48,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.03,
    y: 173.48,
    width: 32.32,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.24,
    y: 185.37,
    width: 32.32,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.91,
    y: 179.98,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.26,
    y: 185.42,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.75,
    y: 185.42,
    width: 77.97,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.97,
    y: 185.42,
    width: 25.16,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.88,
    y: 185.42,
    width: 21.98,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.91,
    y: 191.92,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.24,
    y: 191.92,
    width: 50.06,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.75,
    y: 211.43,
    width: 47.81,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.24,
    y: 198.42,
    width: 33.54,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.5,
    y: 198.42,
    width: 64.68,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.75,
    y: 217.93,
    width: 85.43,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.2,
    y: 191.92,
    width: 48.4,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.44,
    y: 191.92,
    width: 43.02,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.45,
    y: 198.42,
    width: 14.53,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.91,
    y: 198.42,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.26,
    y: 204.93,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.75,
    y: 204.93,
    width: 39.3,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.22,
    y: 204.93,
    width: 39.3,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.27,
    y: 211.43,
    width: 73.6,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.05,
    y: 204.93,
    width: 53.54,
    height: 2.43,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.26,
    y: 211.43,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.37,128.08a.57.57,0,0,1,0,.82.6.6,0,0,1-.4.17.59.59,0,0,1-.42-.17L125,126.3a.05.05,0,0,1,0,0l0,0a.26.26,0,0,1,0-.08,0,0,0,0,1,0,0s0-.05,0-.06,0,0,0,0V126a.2.2,0,0,1,0,0s0,0,0-.05v-.06s0,0,0,0a.64.64,0,0,0,0-.07s0,0,0,0a.56.56,0,0,1,0-.08,0,0,0,0,1,0,0,.13.13,0,0,1,0-.06l2.57-2.6a.59.59,0,0,1,.82,0,.57.57,0,0,1,0,.82l-2.17,2.18Z",
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69,128.37l2.24-5.32a.5.5,0,0,1,.66-.26.49.49,0,0,1,.26.65l-2.24,5.33a.5.5,0,0,1-.46.3.43.43,0,0,1-.19,0A.5.5,0,0,1,130.69,128.37Z",
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.26,126.23h0l-.07.06-2.56,2.6a.6.6,0,0,1-.41.17.57.57,0,0,1-.41-.17.57.57,0,0,1,0-.82L137,125.9l-2.16-2.18a.57.57,0,0,1,0-.82.59.59,0,0,1,.82,0l2.56,2.6.07.06v0s0,0,.05.08,0,0,0,0a.26.26,0,0,0,0,.08s0,0,0,0v.06s0,0,0,.05V126s0,0,0,0a.41.41,0,0,0,0,.08s0,0,0,0Z",
    style: {
      fill: "#4BC46D"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "691.84 425.76 579.88 425.76 602.21 295.91 685.92 295.91 691.84 425.76",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "691.84 425.76 682.02 425.76 676.51 295.91 685.92 295.91 691.84 425.76",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.67,321.45c-9,35.78-17.91,63.14-28.11,69.84-8.22,5.41-19.77,9.2-31.65,11.85a295.75,295.75,0,0,1-38.5,5.51c-4,.33-7.31.54-9.66.7-5.83.37-15.36-38.09-11.24-42.78.95-1.07,4.79-1.9,10.17-2.59,18.13-2.27,53.83-2.8,56-4.83s20.41-27.61,36-47.63C592.42,297.68,603.66,301.62,598.67,321.45Z",
    style: {
      fill: "rgb(173, 99, 89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.43,405.47c-.72.34-11,4.8-17.32,6.38-4.71,1.18-18.36,4.21-20.17-.85-1.25-3.44,6.57-6.17,12.06-8.22,2.89-1.08,6.51-3.93,5.73-5.79-1.34-3.26-8.79-.31-13.71,2.31-9.52,5.07-22.29,14.35-27.81,9.42-2.08-1.87.54-5,4.31-8.09-6.07,3.5-12.5,6.32-14.9,4.34-1.38-1.13-1.39-2.61-.54-4.27-1.85.53-3.46.35-4.55-.88-1.85-2.09-.8-5,1.42-8a2.29,2.29,0,0,1-1.71-1.21c-3.85-6.38,17.24-23.49,24.37-24.9,21-4.18,43-1.56,43-1.56C500.55,371,502.45,405.46,502.43,405.47Z",
    style: {
      fill: "rgb(173, 99, 89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.58,385a34,34,0,0,0-14.06,4.83c-5,3.15-9,7.56-13.62,11.16-.12.1,0,.3.16.19,2.18-1.87,4.56-3.53,6.81-5.31s4.37-3.56,6.68-5.14a33.63,33.63,0,0,1,14-5.64C472.65,385,472.63,385,472.58,385Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469,376c-5.52,1.29-11.17,2.6-16.34,5-5.65,2.63-10.16,7.08-14.6,11.36q-4,3.86-7.81,7.88c-.11.11,0,.3.16.19q6.75-6.63,13.9-12.86a44.5,44.5,0,0,1,15.05-8.73c3.17-1.07,6.42-1.9,9.66-2.73A.05.05,0,0,0,469,376Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.48,368.07c-5.35.9-10,1.66-14.82,4.33-6.36,3.53-12.6,9.66-14.79,11.83-2.42,2.4-4.76,4.88-7.06,7.39-.09.1.08.27.18.17a176.31,176.31,0,0,1,16.78-15.44,35.15,35.15,0,0,1,9.28-5.56,63.21,63.21,0,0,1,10.44-2.68A0,0,0,0,0,463.48,368.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.06,357.51l-32.14-18.95s13.72-22.17,25.45-32.63,16.45-2.25,14.67,12.95S592.06,357.51,592.06,357.51Z",
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565,333.74c5.15,2.63,18.9,10.2,27.16,16.34.05,0-.07.25-.13.22-7.67-4-22.33-13.15-27.22-16.24C564.71,334,564.89,333.69,565,333.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.57,340.12l29.49,17.39s6.19-23.42,8-38.63c1.14-9.82-.42-16.71-4.83-17.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.14,425.76h111c1.23-2.25-17-99.44-54.38-126.8-8.3-6.07-23-2.17-27.12,3.73C569,332.37,560.14,425.76,560.14,425.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.81,299s-14.87,39.77-16.41,58.55C600,363,595.29,426,595.29,426h78.33S658,349.61,632.76,314.14C624.74,302.89,616.81,299,616.81,299Z",
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.08,298.37s-13.2,31.94-16.5,50c-1.82,9.93-11,77.64-11,77.64h-8.41s8.41-72.49,21.72-105.29C586,303.16,593.08,298.37,593.08,298.37Z",
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.82,340.8l18.91,2.35s-1.07,17.55-1.45,18.23-10.52,4.84-11.2,4.46-8.06-5.79-8.42-6.28S606.82,340.8,606.82,340.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.94,320.64c6.59,1.2,17.24-9.31,21.23-17.6.27-.57-3.16-22.53-3.39-27,0-.91-27.4,8.17-27.4,8.17s3.21,9.14,3.56,16.85C588,301.75,587.58,319.47,593.94,320.64Z",
    style: {
      fill: "rgb(173, 99, 89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.51,289.88c-12.18,10.5-25.26,8.19-25.85,8.08a77,77,0,0,0-3.28-13.71s27.36-9.08,27.4-8.17C611.89,278.16,612.7,284.1,613.51,289.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.24,239.85s-7.72,5.6-7.22,14.68,4.67,17.73,5.53,18S571.24,239.85,571.24,239.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.51,242.22c4.63,9.2,4.31,38.13-1.52,45.57-8.46,10.78-24.7,14.45-34.47,3.74-9.47-10.39-8.38-48.08-1.64-55.08C582.8,226.13,603.68,228.63,610.51,242.22Z",
    style: {
      fill: "rgb(173, 99, 89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609,287.79c-8.46,10.78-24.7,14.45-34.47,3.74-3.46-3.79-5.5-11.21-6.38-19.45,0,0,2.38,5.86,5.79,5.9a4.49,4.49,0,0,0,4.3-3.21l1.42-.47a16.49,16.49,0,0,0,16,1.72c9.09-3.77,10.61-14.67,10.61-14.67l7.46.34C613.85,272.28,612.32,283.54,609,287.79Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.57,264c0-.08.15.09.15.17-.08,2,.17,4.19,1.93,4.85.05,0,0,.12,0,.11C585.48,268.79,585.19,265.81,585.57,264Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.32,262c3.14-.22,3.34,6.07.44,6.27S584.69,262.13,587.32,262Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.82,264.62c0-.07-.15.1-.14.18.12,1.94-.06,4.19-1.8,4.9,0,0,0,.12,0,.11C575,269.43,575.25,266.44,574.82,264.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573,262.64c-3.14-.13-3.18,6.16-.27,6.28S575.65,262.76,573,262.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.71,259a23.54,23.54,0,0,1-2.47-.77,4.22,4.22,0,0,1-2.36-1.27,1.34,1.34,0,0,1,.16-1.62,3.3,3.3,0,0,1,3.32-.45,4.87,4.87,0,0,1,2.86,2A1.42,1.42,0,0,1,589.71,259Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.48,259.56a23.52,23.52,0,0,0,2.48-.73,4.16,4.16,0,0,0,2.38-1.23,1.33,1.33,0,0,0-.13-1.62,3.31,3.31,0,0,0-3.3-.51,4.84,4.84,0,0,0-2.9,2A1.42,1.42,0,0,0,570.48,259.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.48,282c-.45.47-.9,1.11-1.6,1.2a5.13,5.13,0,0,1-2.11-.42.07.07,0,0,0-.08.1,2.62,2.62,0,0,0,2.51,1,2.08,2.08,0,0,0,1.47-1.77C588.7,281.92,588.55,281.88,588.48,282Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.24,276.19a6.63,6.63,0,0,1-4.33,3.09,8.25,8.25,0,0,1-2.38.19,2.32,2.32,0,0,1-.46,0,3.56,3.56,0,0,1-.43-.05.49.49,0,0,1-.4-.42v0a1.34,1.34,0,0,1,0-.2h0v-.17c-.09-1.5,0-3.79,0-3.79-.54.3-3.29,1.65-3.27.86.17-6.5.36-13.72,1.91-20.15a.18.18,0,0,1,.36,0c.08,6.26-.94,12.48-1,18.76a11.53,11.53,0,0,1,3.09-1c.22,0-.21,4.41-.12,5.08a.17.17,0,0,0,0,.07c2.53.24,4.4-.58,6.79-2.35C586.19,275.9,586.35,276,586.24,276.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.39,278.68a7.91,7.91,0,0,0,3.23,2.34,3.5,3.5,0,0,0,2.15.06c1.55-.46,1.54-1.89,1.21-3.1a8.18,8.18,0,0,0-.76-1.85A10.21,10.21,0,0,1,580.39,278.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.62,281a3.5,3.5,0,0,0,2.15.06c1.55-.46,1.54-1.89,1.21-3.1C585.32,278.21,583.71,279.39,583.62,281Z",
    style: {
      fill: "#ff99ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.19,270c-3.46,1.06-7.46-9.33-8.59-13.33-1-3.53-2.16-14.71-2.33-15.47s-15.07,9.92-23.79,7.39-14.57-10.35-14.7-14,10.69-12.94,20.06-13.43,22.07,11.4,22.07,11.4-4.32-5.14-4.17-5.56,6.2,2,7.32,6.3c0,0-1.2-5.42-.75-5.52s5.17,4.53,4.12,8.05c0,0,5.45,4.7,6,9.87S617.25,268.76,613.19,270Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.28,246.79c2.65,1.22,5.31,2.56,8.24,2.94a19.72,19.72,0,0,0,9.4-1.52,29.67,29.67,0,0,0,8.24-4.9c2.17-1.8,4.11-4,6.43-5.57.58-.4,1.26.44.9,1a31.24,31.24,0,0,1-15.8,11.68c-6.34,2-12.31.61-17.45-3.53C572.21,246.84,572.23,246.77,572.28,246.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.44,266.11s5-10.06,9.46-8.42,1.67,15.56-2.9,18.1a5,5,0,0,1-7-1.66Z",
    style: {
      fill: "rgb(173, 99, 89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617,261.66c.07,0,.11.09,0,.13-3.19,1.89-4.5,5.31-5.26,8.76.82-1.41,2.09-2.3,4-1.35.09.05,0,.2-.07.19a3.08,3.08,0,0,0-3.18,1.56,15.34,15.34,0,0,0-1.19,2.94c-.11.33-.68.25-.62-.12a.31.31,0,0,1,0-.08C610,269.37,612.41,262.8,617,261.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.18,310.75c21.51,27,50.08,74.36,37.24,84.06-21.11,15.93-81.19,23.19-94.95,24.28-5.94.48-16.22-38.63-12.08-43.47s67.4-5.82,68-9.68c.34-2.18-8.47-21.69-13.69-45.38C611.68,293.24,627.12,303.13,633.18,310.75Z",
    style: {
      fill: "rgb(173, 99, 89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.86,372.85s-18.1-.86-30-.88c-6.62,0-18,1-22.83,3.22-7.28,3.32-35.6,21.86-31.25,28.82,3.93,6.3,26.24-12.71,26.24-12.71S491.84,408.49,498,415.21s28.48-18.11,28.48-18.11S502,415.32,509.4,421.25c5.61,4.48,27.11-16.87,27.11-16.87S515.59,420.19,521.16,425c6.15,5.37,27.24-13.1,27.24-13.1,16.23,10,28,8.06,36.27,5.71C586.66,417.09,573.86,372.85,573.86,372.85Z",
    style: {
      fill: "rgb(173, 99, 89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524,384.81c-2.92,1.92-5.88,3.84-8.62,6s-5.4,4.44-7.92,6.85A60.6,60.6,0,0,0,498.58,408c5.05-6.36,14.72-14.28,17.46-16.45s5.35-4.47,8.08-6.64C524.19,384.86,524.11,384.77,524,384.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.05,394.55c-3.62,2.61-7.3,5.07-10.81,7.84s-8.24,6.78-11.53,9.77c-.25.23,0,.69.24.47,3.4-2.85,8.44-6.74,11.88-9.56s6.77-5.76,10.29-8.44C532.18,394.59,532.11,394.51,532.05,394.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.43,401.67c-5.73,3.7-10.77,8.46-15.61,13.25-.24.24,0,.28.3.05,5.1-4.5,9.08-8.06,15.44-13.1C540.66,401.79,540.55,401.59,540.43,401.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.44,372.39c-8.27-.39-32.53-1.43-40.8-1.13-7.29.26-13.39,1.59-19.68,5.39-13.48,8.15-22.35,18-24.57,21-1.35,1.79-3.33,4.64-1.71,6.75,2,2.57,9.67.45,18-6.49.3-.25.13-.43-.18-.2-11.65,8.69-16.1,7.45-17.21,5.84-.72-1,.08-2.76.82-4.07a26.11,26.11,0,0,1,4.21-5.16A112.29,112.29,0,0,1,513,380a43.72,43.72,0,0,1,23.17-7.64c8.47-.36,31.83.81,40.29.33C576.63,372.69,576.61,372.4,576.44,372.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.78,411.53c.56-2.24,2.26-4.23,3.62-6a41.42,41.42,0,0,1,5.62-6.28c.09-.08.23,0,.15.13a67.18,67.18,0,0,0-5,6.06,37.81,37.81,0,0,0-2.24,3.64c-.65,1.2-1.4,2.6-1.15,4,.47,2.71,3.88,2.78,5.93,2.13a22.53,22.53,0,0,0,3.84-1.67,39.42,39.42,0,0,0,4.75-3.29c.13-.11.44-.05.31.06-3.12,2.75-9.06,8.48-13.62,6.1A4.21,4.21,0,0,1,496.78,411.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.68,338.68l-34.36,14.54s-9.64-24.22-11.07-39.87,8-14.56,19.14-4.08S659.68,338.68,659.68,338.68Z",
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.46,346.28c5.18-2.57,19.45-9.12,29.31-12.1.05,0,.15.21.1.24-7.79,3.77-23.86,10.11-29.26,12.2C624.51,346.66,624.36,346.33,624.46,346.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617,333.37a.05.05,0,0,1,.09,0c.7,1.18,1.32,2.37,1.92,3.6-.75-2.71-1.45-5.43-2.08-8.16,0-.1.11-.13.15,0,2.79,8,5.78,15.86,8.4,23.87.89-.09,1.79-.2,2.67-.37a.12.12,0,0,1,.06.23c-.95.29-1.89.65-2.82,1a.46.46,0,0,1-.62-.17,118.69,118.69,0,0,1-5-13.9c-.41-.71-.81-1.42-1.17-2.16A30.28,30.28,0,0,1,617,333.37Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "75.17 425.76 187.12 425.76 164.8 295.91 81.08 295.91 75.17 425.76",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.17 425.76 84.98 425.76 90.49 295.91 81.08 295.91 75.17 425.76",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.11,343.15l-12.52.13c-2.26-4.15-4.84-11.49-3.31-21.81.26-1.7-4.32,8.07-3.05,21.88-13.22.14-31.2.32-46.91.34-.12-5.81-.51-11.18-.51-11.18a61.66,61.66,0,0,1-2.91,11.19c-2.14,0-4.25,0-6.27,0,.74-9-.39-24.73-.39-24.73a77.65,77.65,0,0,1-8.53,24.69c-10-.09-16.53-.32-16.09-.76,15.59-16.19,4.84-25.75,9.58-40.12,5.68-17.21,21.49-19.76,21.43-32.74,0-10.56-.81-29.74,13.4-33.66,0,0,11.83-11.74,29.62-5,22,8.34,12.18,40.8,13.49,47.44,1.87,9.48,6.52,12.88,9.74,23.71s-2.2,18.14-3,25.54S195.62,343.16,193.11,343.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.25,340.56a36.78,36.78,0,0,0,5.12-9.19c1.24-3.2.85-6.5.27-9.91A96.44,96.44,0,0,1,96.13,311a26.33,26.33,0,0,1,1.44-10.85,24.57,24.57,0,0,1,6.29-9.29,69.22,69.22,0,0,1,8.78-6.79,41.58,41.58,0,0,0,8.13-6.84,18.79,18.79,0,0,0,4.29-9.39,17.29,17.29,0,0,1-3.2,10.13A37.54,37.54,0,0,1,114,285.7a85.63,85.63,0,0,0-8.17,6.9,23.14,23.14,0,0,0-5.47,8.42A26,26,0,0,0,99,310.84c.1,3.38.66,6.79,1,10.3a33,33,0,0,1,.2,5.38,15,15,0,0,1-1.43,5.35A30.93,30.93,0,0,1,92.25,340.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.86,243.66c1.61,4,2.11,8.37,2.63,12.64s.65,8.59.81,12.87l.29,6.4a30.4,30.4,0,0,0,.82,6.12c1,4,3.22,7.45,5.75,11a49,49,0,0,1,3.46,5.69,28.68,28.68,0,0,1,2.28,6.33,42.4,42.4,0,0,1,.77,6.6,26.31,26.31,0,0,1-.59,6.67c-.48,2.19-1.2,4.26-1.81,6.3a31.61,31.61,0,0,0-1.23,6.18c-.46,4.1,1.7,8.23,5.13,11a13,13,0,0,1-6.54-11,30.72,30.72,0,0,1,.78-6.56c.47-2.15,1.1-4.21,1.41-6.25a32.27,32.27,0,0,0-.65-12.3,28.11,28.11,0,0,0-2.16-5.73,45.53,45.53,0,0,0-3.34-5.35,62.47,62.47,0,0,1-3.54-5.59,25.23,25.23,0,0,1-2.44-6.31,32,32,0,0,1-.69-6.62c-.06-2.17,0-4.32,0-6.47,0-4.29.14-8.57.06-12.84A59.21,59.21,0,0,0,178.86,243.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.48,321.5c7.13,31,21.55,70.33,32.7,78.26,9,6.39,56.15,17.66,58.78,17.94,6.51.66,19.37-45.34,12.62-47.21-8.5-2.35-48.92-3.61-51.22-6s-17.1-22.39-33.75-45.46C158.12,303.11,146.06,302.24,150.48,321.5Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.73,415.17c.78.4,11.79,5.93,18.6,7.91,5.08,1.47,19.82,5.32,22-.11,1.49-3.71-6.92-7-12.8-9.44-3.11-1.3-6.93-4.54-6-6.54,1.59-3.48,9.58,0,14.83,3.07,10.16,5.9,23.68,16.52,29.89,11.37,2.34-1.95-.38-5.5-4.37-9,6.47,4.05,13.36,7.37,16.05,5.31,1.54-1.17,1.62-2.78.76-4.62,2,.65,3.76.52,5-.78,2.11-2.2,1.08-5.44-1.22-8.77a2.51,2.51,0,0,0,1.91-1.25c4.45-6.79-17.82-26.26-25.52-28.08-22.66-5.39-46.76-3.43-46.76-3.43C240.17,378,236.72,415.16,236.73,415.17Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.05,394.31a38.56,38.56,0,0,1,15.11,5.82c5.75,3.79,9.56,8.23,14.38,12.7.12.12-.05.32-.18.2-2.3-2.12-11.81-10.11-14.27-11.93A36.64,36.64,0,0,0,270,394.41C270,394.4,270,394.31,270.05,394.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.27,384.7c6,1.63,12.06,3.28,17.59,6.09,6.05,3.08,10.78,8.11,15.43,12.95q4.2,4.35,8.19,8.89c.11.13-.06.33-.18.2q-7.08-7.49-14.61-14.55a48.51,48.51,0,0,0-16-10.11c-3.4-1.3-6.9-2.33-10.4-3.36C274.19,384.79,274.21,384.68,274.27,384.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.63,376.29c5.79,1.19,10.84,2.21,16,5.31,6.78,4.1,13.33,11,15.63,13.47,2.54,2.71,5,5.5,7.38,8.33.1.11-.1.28-.2.17a191.58,191.58,0,0,0-17.65-17.48,38.26,38.26,0,0,0-9.87-6.42,68.89,68.89,0,0,0-11.25-3.34S280.61,376.29,280.63,376.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,360l-43.47-1.85s-7.9-21.54-10.8-40.66,13.39-12.26,29.53,8.34S203,360,203,360Z",
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.54,319.88a1.93,1.93,0,0,1-.83.42,1.67,1.67,0,0,1-1.55-.48,2.17,2.17,0,0,0-2.39-.41,2.13,2.13,0,0,0-.89.78c-.2.3-.42.58-.6.9.32-.18.6-.4.9-.6a2,2,0,0,1,.83-.44,1.64,1.64,0,0,1,1.55.4,2.2,2.2,0,0,0,2.37.5,2.14,2.14,0,0,0,.91-.76c.2-.3.42-.58.6-.91C161.12,319.47,160.84,319.69,160.54,319.88ZM162.92,340c-.07-.35-.11-.71-.21-1.06-.1.35-.14.71-.22,1.06a2,2,0,0,1-.27.9,1.63,1.63,0,0,1-1.38.81,2.12,2.12,0,0,0-2.14,2.51c.07.35.12.71.22,1.06.1-.35.14-.71.21-1.06a1.88,1.88,0,0,1,.3-.88,1.66,1.66,0,0,1,1.42-.76,2.17,2.17,0,0,0,2-1.4A2.1,2.1,0,0,0,162.92,340Zm30.89,16.17,0,.09a1.63,1.63,0,0,1-1.39.81,2.2,2.2,0,0,0-2,1.33,1.9,1.9,0,0,0-.14,1.07l.47,0a1.91,1.91,0,0,1,.28-.78,1.65,1.65,0,0,1,1.43-.77,2.19,2.19,0,0,0,1.71-.87h0Zm-18,1.85a2,2,0,0,1-.83.44,1.62,1.62,0,0,1-1.54-.41,2.18,2.18,0,0,0-2.37-.49,2.11,2.11,0,0,0-.92.76,2.83,2.83,0,0,1-.2.28l.5,0a2.08,2.08,0,0,1,.83-.41,1.69,1.69,0,0,1,1.55.47l.06.05,2.73.11a2.37,2.37,0,0,0,.49-.52c.2-.3.42-.58.6-.9C176.36,357.59,176.08,357.81,175.78,358Zm8-22.53a1.91,1.91,0,0,1-.87-.29,1.65,1.65,0,0,1-.76-1.43,2.13,2.13,0,0,0-2.58-2.07c-.36.08-.71.12-1.07.22.36.1.71.14,1.07.21a2.12,2.12,0,0,1,.89.27,1.65,1.65,0,0,1,.81,1.39,2.17,2.17,0,0,0,1.33,2,2,2,0,0,0,1.18.11c.36-.07.71-.11,1.06-.21C184.45,335.6,184.1,335.56,183.74,335.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.06,348.72c9.4-.24,18.83.17,28.23.78q4,.25,8,.69c.08,0,.08.12,0,.12-4.7,0-9.4-.15-14.1-.29s-9.42-.33-14.13-.61c-2.66-.15-5.31-.31-8-.52A.09.09,0,1,1,158.06,348.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.16,359.75l-37.62-1.6s-7.9-21.54-10.8-40.66c-1.23-8.14,1-11.57,5.23-11.24h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.18,425.64H80.91S104,336.5,125.36,311.41c.48-.58,1-1.13,1.46-1.64l.29-.3a22.81,22.81,0,0,1,5.71-4.42c.38-.2.75-.39,1.14-.56,8.23-3.78,16.92-.65,23.19,4.72,2,1.7,24.52,31,26.51,42.18,1.72,9.87-4.94,20.46-4.94,20.46Z",
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.72,331.69a1.91,1.91,0,0,1-.87-.29,1.65,1.65,0,0,1-.76-1.43,2.13,2.13,0,0,0-2.58-2.07c-.36.07-.71.12-1.06.22.35.09.7.14,1.06.21a2,2,0,0,1,.89.27,1.63,1.63,0,0,1,.81,1.38,2.2,2.2,0,0,0,1.33,2,2,2,0,0,0,1.18.11c.36-.07.71-.11,1.07-.21C140.43,331.81,140.08,331.76,139.72,331.69Zm19.61,70.15a2,2,0,0,1-.87-.3,1.65,1.65,0,0,1-.76-1.43,2.11,2.11,0,0,0-2.58-2.06c-.36.07-.71.11-1.06.21.35.1.7.14,1.06.21a2.27,2.27,0,0,1,.89.27,1.64,1.64,0,0,1,.81,1.39,2.19,2.19,0,0,0,1.33,2,2.13,2.13,0,0,0,1.18.12c.36-.08.71-.12,1.07-.22C160,402,159.69,401.91,159.33,401.84ZM111.91,361a1.91,1.91,0,0,1-.87-.29,1.68,1.68,0,0,1-.77-1.43,2.15,2.15,0,0,0-1.39-2,2.19,2.19,0,0,0-1.18-.08c-.36.07-.71.12-1.07.21.36.1.71.15,1.07.22a2,2,0,0,1,.89.27,1.65,1.65,0,0,1,.81,1.38,2.17,2.17,0,0,0,1.33,2,2,2,0,0,0,1.18.11c.36-.07.71-.12,1.06-.21C112.62,361.16,112.27,361.11,111.91,361Zm41.89,64.27a2,2,0,0,1-.88-.29,1.67,1.67,0,0,1-.76-1.43,2.13,2.13,0,0,0-2.58-2.07c-.35.07-.71.12-1.06.21.35.1.71.15,1.06.22a2,2,0,0,1,.9.27,1.65,1.65,0,0,1,.81,1.38,2.18,2.18,0,0,0,1.32,2h1.72a5,5,0,0,0,.53-.11C154.51,425.43,154.15,425.38,153.8,425.31Zm-20.63-34.53a2.09,2.09,0,0,1-.87-.3,1.65,1.65,0,0,1-.76-1.43,2.15,2.15,0,0,0-1.4-2A2.1,2.1,0,0,0,129,387c-.36.07-.71.11-1.06.21.35.1.7.14,1.06.21a2.27,2.27,0,0,1,.89.27,1.64,1.64,0,0,1,.81,1.39,2.19,2.19,0,0,0,1.33,2,2.13,2.13,0,0,0,1.18.12c.36-.08.71-.12,1.07-.22C133.88,390.89,133.53,390.85,133.17,390.78Zm-51.43,32-.07,0h0l-.12.47.2,0c.35-.08.7-.12,1.06-.22A10.44,10.44,0,0,0,81.74,422.82ZM95,397.05a1.91,1.91,0,0,1-.87-.29,1.65,1.65,0,0,1-.76-1.43,2.13,2.13,0,0,0-2.58-2.07l-.63.12-.06.18.69.13a2,2,0,0,1,.89.27,1.65,1.65,0,0,1,.81,1.38,2.17,2.17,0,0,0,1.33,2,2,2,0,0,0,1.18.11c.36-.07.71-.11,1.06-.21C95.73,397.17,95.38,397.12,95,397.05Zm55.72-35.16a2.08,2.08,0,0,1-.88-.3,1.67,1.67,0,0,1-.76-1.43,2.15,2.15,0,0,0-1.4-2,2.1,2.1,0,0,0-1.18-.08c-.35.07-.71.11-1.06.21.35.1.71.14,1.06.21a2.33,2.33,0,0,1,.9.27,1.65,1.65,0,0,1,.8,1.39,2.19,2.19,0,0,0,1.33,2,2.15,2.15,0,0,0,1.19.12c.35-.08.71-.12,1.06-.22C151.45,362,151.09,362,150.74,361.89Zm29.31,18.4a2.08,2.08,0,0,1-.77-.28,1.67,1.67,0,0,1-.76-1.43,2.16,2.16,0,0,0-1.4-2,2.19,2.19,0,0,0-1.18-.07c-.35.07-.7.11-1.06.21.36.1.71.14,1.06.21a2.27,2.27,0,0,1,.9.27,1.66,1.66,0,0,1,.81,1.39,2.17,2.17,0,0,0,1.32,2,2.1,2.1,0,0,0,1.15.12ZM175.78,358a2,2,0,0,1-.83.44,1.62,1.62,0,0,1-1.54-.41,2.18,2.18,0,0,0-2.37-.49,2.11,2.11,0,0,0-.92.76c-.2.3-.42.58-.6.9.32-.18.6-.4.9-.6a2.08,2.08,0,0,1,.83-.41,1.69,1.69,0,0,1,1.55.47,2.15,2.15,0,0,0,2.39.42,2.2,2.2,0,0,0,.89-.78c.2-.3.42-.58.6-.9C176.36,357.59,176.08,357.81,175.78,358ZM139.72,304c-.07-.33-.11-.67-.19-1h0c-.08.33-.12.67-.19,1a2.12,2.12,0,0,1-.27.9,1.65,1.65,0,0,1-1.39.8,2.2,2.2,0,0,0-2,1.33,2.06,2.06,0,0,0-.11,1.19c.07.35.11.71.21,1.06.1-.35.14-.71.22-1.06a2,2,0,0,1,.29-.88,1.67,1.67,0,0,1,1.43-.76,2.11,2.11,0,0,0,2.06-2.58Zm-8.44,62.33c-.07-.35-.11-.7-.21-1.06-.1.36-.14.71-.22,1.06a2,2,0,0,1-.27.9,1.63,1.63,0,0,1-1.38.81,2.18,2.18,0,0,0-2,1.33,2.1,2.1,0,0,0-.11,1.18c.07.35.12.71.22,1.06.1-.35.14-.71.21-1.06a1.88,1.88,0,0,1,.3-.88,1.68,1.68,0,0,1,1.42-.76,2.15,2.15,0,0,0,2-1.4A2.19,2.19,0,0,0,131.28,366.28Zm43.93,46.39c-.07-.36-.12-.71-.22-1.07-.09.36-.14.71-.21,1.07a2,2,0,0,1-.27.89,1.65,1.65,0,0,1-1.38.81,2.17,2.17,0,0,0-2,1.33,2,2,0,0,0-.11,1.18c.07.35.11.71.21,1.06.1-.35.15-.71.22-1.06a2,2,0,0,1,.29-.88,1.69,1.69,0,0,1,1.43-.76,2.15,2.15,0,0,0,2-1.39A2.21,2.21,0,0,0,175.21,412.67Zm-61.47-80.23c-.07-.36-.12-.71-.21-1.07-.1.36-.15.71-.22,1.07a2,2,0,0,1-.27.89,1.69,1.69,0,0,1-1.05.77c-.15.3-.29.61-.43.92h.11a2.13,2.13,0,0,0,2.07-2.58ZM162.92,340c-.07-.35-.11-.71-.21-1.06-.1.35-.14.71-.22,1.06a2,2,0,0,1-.27.9,1.63,1.63,0,0,1-1.38.81,2.12,2.12,0,0,0-2.14,2.51c.07.35.12.71.22,1.06.1-.35.14-.71.21-1.06a1.88,1.88,0,0,1,.3-.88,1.66,1.66,0,0,1,1.42-.76,2.17,2.17,0,0,0,2-1.4A2.1,2.1,0,0,0,162.92,340Zm-45.45,63.12c-.08-.35-.12-.7-.22-1.06-.1.36-.14.71-.21,1.06a2.12,2.12,0,0,1-.27.9,1.66,1.66,0,0,1-1.39.81,2.18,2.18,0,0,0-2,1.32,2.06,2.06,0,0,0-.11,1.19c.07.35.11.71.21,1.06.1-.35.14-.71.22-1.06a2,2,0,0,1,.29-.88,1.67,1.67,0,0,1,1.43-.76,2.13,2.13,0,0,0,2.07-2.58Zm43.07-83.23a1.93,1.93,0,0,1-.83.42,1.67,1.67,0,0,1-1.55-.48,2.17,2.17,0,0,0-2.39-.41,2.13,2.13,0,0,0-.89.78c-.2.3-.42.58-.6.9.32-.18.6-.4.9-.6a2,2,0,0,1,.83-.44,1.64,1.64,0,0,1,1.55.4,2.2,2.2,0,0,0,2.37.5,2.14,2.14,0,0,0,.91-.76c.2-.3.42-.58.6-.91C161.12,319.47,160.84,319.69,160.54,319.88Zm-28.69,26a1.8,1.8,0,0,1-.83.41,1.67,1.67,0,0,1-1.55-.47,2.15,2.15,0,0,0-2.39-.42,2.2,2.2,0,0,0-.89.78c-.2.3-.42.58-.6.9.32-.18.6-.4.9-.6a2.24,2.24,0,0,1,.83-.44,1.67,1.67,0,0,1,1.55.41,2.17,2.17,0,0,0,2.37.49,2.07,2.07,0,0,0,.91-.76c.2-.3.42-.58.6-.9C132.43,345.45,132.15,345.67,131.85,345.87Zm-19.44,38.28a2,2,0,0,1-.82.42,1.67,1.67,0,0,1-1.55-.48,2.18,2.18,0,0,0-2.4-.41,2.13,2.13,0,0,0-.89.78c-.2.3-.42.58-.6.9.32-.18.6-.4.91-.6a1.89,1.89,0,0,1,.82-.44,1.63,1.63,0,0,1,1.55.4,2.2,2.2,0,0,0,2.37.5,2.11,2.11,0,0,0,.92-.76c.2-.3.42-.58.6-.91C113,383.73,112.72,384,112.41,384.15Zm8.41,39.78a2,2,0,0,1-.83.42,1.67,1.67,0,0,1-1.55-.48,2.18,2.18,0,0,0-2.4-.41,2.13,2.13,0,0,0-.89.78c-.19.3-.41.58-.6.9.33-.18.61-.4.91-.6a2,2,0,0,1,.82-.44,1.63,1.63,0,0,1,1.55.4,2.2,2.2,0,0,0,2.37.5,2.11,2.11,0,0,0,.92-.76c.2-.3.42-.58.6-.91C121.4,423.51,121.12,423.74,120.82,423.93Zm37.61-43.71a2,2,0,0,1-.83.41,1.67,1.67,0,0,1-1.55-.47,2.17,2.17,0,0,0-2.4-.42,2.11,2.11,0,0,0-.88.78c-.2.3-.42.58-.61.9.33-.18.61-.4.91-.6a2.2,2.2,0,0,1,.82-.44,1.63,1.63,0,0,1,1.55.41,2.18,2.18,0,0,0,2.37.49,2.11,2.11,0,0,0,.92-.76c.2-.3.42-.58.6-.9C159,379.8,158.73,380,158.43,380.22Zm24.15,16.19a1.56,1.56,0,0,1-.64-.41,2.21,2.21,0,0,0-2.4-.42,2.28,2.28,0,0,0-.89.78c-.2.31-.42.59-.6.91.32-.18.6-.4.9-.6a2.13,2.13,0,0,1,.83-.45,1.67,1.67,0,0,1,1.55.41,2.2,2.2,0,0,0,1.39.64Zm-41.81,11.68a2,2,0,0,1-.83.41,1.67,1.67,0,0,1-1.55-.47,2.12,2.12,0,0,0-3.28.36c-.2.3-.42.58-.6.9.32-.18.6-.4.9-.6a2.2,2.2,0,0,1,.82-.44,1.63,1.63,0,0,1,1.55.41,2.18,2.18,0,0,0,2.37.49,2,2,0,0,0,.92-.76c.2-.3.42-.58.6-.9C141.35,407.67,141.07,407.89,140.77,408.09Zm-40.07,5.48a2,2,0,0,1-.83.41,1.67,1.67,0,0,1-1.55-.47,2.15,2.15,0,0,0-2.39-.42,2.08,2.08,0,0,0-.89.78c-.2.3-.42.58-.61.9.33-.18.61-.4.91-.6a2.2,2.2,0,0,1,.82-.44,1.63,1.63,0,0,1,1.55.41,2.18,2.18,0,0,0,2.37.49,2,2,0,0,0,.92-.76c.2-.3.42-.58.6-.9C101.28,413.15,101,413.37,100.7,413.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.77,368a92.29,92.29,0,0,0-13.42,2.32c-2.19.58-4.33,1.26-6.47,2-1.07.36-2.14.68-3.22,1a14.64,14.64,0,0,1-3.46.69c-.1,0-.1.16,0,.16a24.65,24.65,0,0,0,3.33-.09,23.22,23.22,0,0,0,3.18-.63c2.22-.57,4.41-1.24,6.63-1.83,4.47-1.19,8.93-2.38,13.48-3.24C163,368.37,163,368,162.77,368Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,372a98.15,98.15,0,0,0-11.24-.44c-1.88,0-3.74.18-5.6.38l-2.67.33c-1,.13-1.94.39-2.92.51a.09.09,0,0,0,0,.17c.92-.09,1.87,0,2.8,0l2.8-.1c1.87-.06,3.74-.1,5.61-.18,3.74-.16,7.47-.28,11.21-.31C174.21,372.26,174.19,372,174,372Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.27,313.81C105.36,333,62.74,405,76.56,418.28s90.49-4.6,112-14.86c6.41-3.05-17.94-43-25.47-43.93-6.27-.78-38.32,13.89-39.25,12-1-2.08,6.24-15.46,13.95-43.3C146.71,296.12,131.19,305.33,123.27,313.81Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,346.6c15.58-2.17,19.91-.34,32.08-9.15,8-5.78,15.1-3.16,10.54,6-7.45,15-26.95,22-34.41,22.52Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.59,361.59s17.5-9.72,33.86-13.67c11.32-2.73,36.61-5.94,60.8,19,5.74,5.92,9.72,18.42-3.17,12.16-9.15-4.45-13.61-10-19.4-11.65,0,0,3.18,16.5-3,22a152.83,152.83,0,0,1-17.1,13.27,31.78,31.78,0,0,1-2.77-3s-6.23,4.61-18,3.5Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.67,347c5.41,2.82,16.78,9,24.32,17.27,8.38,9.2,22,29.18,15.19,35.3-5,4.48-10.92-2.69-10.92-2.69s3.91,9.45-1.52,12.51c-4.94,2.78-9.16-3-9.16-3s1.38,6.14-3.9,7.91c-6.35,2.12-8.21-11.09-16.5-14.5C194.32,399,198.67,347,198.67,347Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.8,371.54c4.65,3.49,13.19,14.12,15.55,25.14.05.25-.11.42-.21.2a122.25,122.25,0,0,0-15.43-25.26C211.67,371.57,211.74,371.5,211.8,371.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.75,380.27c3.71,3.42,12,14.78,14,26,0,.25-.13.41-.22.19a131.16,131.16,0,0,0-13.9-26.14S202.71,380.23,202.75,380.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.68,367.34c5.08,1.49,8.38,4,12.66,7a66.64,66.64,0,0,0,6.54,4.14c2.07,1.12,5.12,2.81,7.32,1.06,1.22-1,1.2-2.75.93-4.14a11.06,11.06,0,0,0-1.84-4.39c0-.06.07-.15.12-.08a15,15,0,0,1,2.1,3.75,6.83,6.83,0,0,1,.46,4c-.75,2.8-4.05,3.17-6.39,2.4a22.27,22.27,0,0,1-4-1.94c-1.23-.7-2.43-1.47-3.6-2.26-2.41-1.63-4.73-3.4-7.12-5.06a65.64,65.64,0,0,0-7.26-4.22A.09.09,0,0,1,225.68,367.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.31,385.19c-1.31-2.89-8.42-14.94-10.73-17.73a.07.07,0,0,1,.11-.1c3.95,3.75,10.31,13.71,11.79,16.9s3.15,7.18,3.15,10.7c0,5.3-3.52,6.3-4.82,6.56a6.88,6.88,0,0,1-4.51-.74,13.86,13.86,0,0,1-4.09-3.84c-.05-.07,0-.17.11-.1,1.83,2.09,4.89,4.15,7.77,3.77a4.81,4.81,0,0,0,3.28-1.77,6.29,6.29,0,0,0,.84-4.27A28.81,28.81,0,0,0,236.31,385.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.78,406.29c.74.63,2.26,2.83,4.67,3.3a5.51,5.51,0,0,0,5-1.11,6.91,6.91,0,0,0,1.9-4.82,43.21,43.21,0,0,0-1.11-6.68c0-.1.11-.15.14-.05a24.78,24.78,0,0,1,1.59,7.18,7.2,7.2,0,0,1-2,5.28,5.42,5.42,0,0,1-5.55,1.16c-.94-.36-3.93-2.27-4.79-4.16C216.56,406.35,216.75,406.26,216.78,406.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.68,398.85a13.1,13.1,0,0,1,2.25,1.9c.74.71,1.46,1.46,2.16,2.22a30.2,30.2,0,0,1,3.67,5c1.07,1.8,2.06,3.8,3.8,5.05a5,5,0,0,0,5.81.15,4.91,4.91,0,0,0,1.81-2.69,9.63,9.63,0,0,0,.34-3.62.07.07,0,1,1,.14,0,16.38,16.38,0,0,1,.26,3.28,5.79,5.79,0,0,1-1,2.8,5.53,5.53,0,0,1-5.41,2,8.11,8.11,0,0,1-5-3.88c-1.34-2-2.45-4.14-3.88-6.09-.75-1-1.49-2.06-2.31-3s-1.89-1.91-2.68-3A.1.1,0,0,1,196.68,398.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.48,403.37A45,45,0,0,0,199,401.6c.09,0,.22.22.14.27a20.71,20.71,0,0,1-4.21,1.39,15.06,15.06,0,0,1-4.44.27C190.42,403.52,190.38,403.38,190.48,403.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.88,385.54A112.19,112.19,0,0,1,109,377.48a109.9,109.9,0,0,1,15-5.8c2.92-.92,5.87-1.7,8.82-2.5.09,0,.12.11,0,.14A138.77,138.77,0,0,0,117.67,375q-7.36,3.18-14.6,6.62c-2.73,1.3-5.4,2.72-8.09,4.11A.1.1,0,1,1,94.88,385.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.58,359.06l43.49-1.44s8.09-21.46,11.17-40.56-12.56-13.26-28.88,7.18S86.58,359.06,86.58,359.06Z",
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.49,346.77a1.85,1.85,0,0,1-.83.41,1.62,1.62,0,0,1-1.48-.41c-.17.24-.35.48-.51.72a2.16,2.16,0,0,0,2.2.34,2,2,0,0,0,.92-.75c.2-.31.42-.59.6-.91C98.07,346.35,97.79,346.57,97.49,346.77Zm34.36-.9a1.8,1.8,0,0,1-.83.41,1.67,1.67,0,0,1-1.55-.47,2.15,2.15,0,0,0-2.39-.42,2.2,2.2,0,0,0-.89.78c-.2.3-.42.58-.6.9.32-.18.6-.4.9-.6a2.24,2.24,0,0,1,.83-.44,1.67,1.67,0,0,1,1.55.41,2.17,2.17,0,0,0,2.37.49,2.07,2.07,0,0,0,.91-.76c.2-.3.42-.58.6-.9C132.43,345.45,132.15,345.67,131.85,345.87Zm-18.11-13.43c-.07-.36-.12-.71-.21-1.07-.1.36-.15.71-.22,1.07a2,2,0,0,1-.27.89,1.65,1.65,0,0,1-1.38.81,2.2,2.2,0,0,0-2,1.33,2,2,0,0,0-.11,1.18c.07.36.12.71.22,1.07.09-.36.14-.71.21-1.07a1.8,1.8,0,0,1,.3-.87,1.62,1.62,0,0,1,1.42-.76,2.13,2.13,0,0,0,2.07-2.58ZM138,305.61h0a1.24,1.24,0,0,1-.33,0,2.2,2.2,0,0,0-2,1.33,2.06,2.06,0,0,0-.11,1.19c.07.35.11.71.21,1.06.1-.35.14-.71.22-1.06a2,2,0,0,1,.29-.88,1.67,1.67,0,0,1,1.43-.76A2.17,2.17,0,0,0,139,306,4.21,4.21,0,0,0,138,305.61ZM117.92,317.8a2.08,2.08,0,0,0,.83-.74l.31-.44C118.68,317,118.3,317.4,117.92,317.8Zm-9,39.53a2.19,2.19,0,0,0-1.18-.08c-.36.07-.71.12-1.07.21.36.1.71.15,1.07.22a2,2,0,0,1,.89.27,1.72,1.72,0,0,1,.43.37l1,0h0A2.1,2.1,0,0,0,108.88,357.33ZM138.09,330a2.13,2.13,0,0,0-2.58-2.07c-.36.07-.71.12-1.06.22.35.09.7.14,1.06.21a2,2,0,0,1,.89.27,1.63,1.63,0,0,1,.81,1.38,2.21,2.21,0,0,0,.91,1.79c.07-.3.15-.59.22-.89A1.58,1.58,0,0,1,138.09,330Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.28,357.48c.23,0,1.76-.27,1.77-.27.11-.57,2.59-9.54,3.24-11.5,1.33-4,2.89-7.89,4.4-11.8.05-.12.24-.07.2.06-1,3.37-1.9,6.76-2.91,10.12.3-.48.6-1,.89-1.45.59-1,1.1-2,1.65-3.05,0-.09.2,0,.17.08a17.13,17.13,0,0,1-1.92,4,15.62,15.62,0,0,1-1.13,1.54c-.09.27-.17.56-.26.83-.61,2-3.8,11.68-4,11.69l-2.1,0C128.2,357.77,128.16,357.48,128.28,357.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.62,350.64c9.38-.7,18.82-.74,28.24-.6q4,.06,8,.31c.08,0,.09.11,0,.11-4.69.25-9.39.31-14.09.4s-9.43.14-14.14.09c-2.66,0-5.32-.05-8-.13A.09.09,0,0,1,93.62,350.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.36,305.73c.17,1.9,7.23,15.09,15.69,15.9,2.76.26,4.84-14.72,4.84-14.72l.41-1.07,5.68-15-16.51-14.28-2.41-1.93s-1.28,4.21-2.83,9.46c-.07.24-.15.48-.22.74s-.19.58-.27.86c-.24.78-.48,1.58-.71,2.38-.17.6-.34,1.2-.5,1.84s-.34,1.27-.51,1.92A102,102,0,0,0,138.36,305.73Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.23,284.11a32.13,32.13,0,0,0,16.07,21.73l5.68-15-16.51-14.28-2.41-1.93S144.78,278.86,143.23,284.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.22,259.84c7.67,27.07-7.68,34.72-13.52,36.37-5.3,1.49-23.54,5.91-34-20.22s-.26-38.25,11.68-42.31S177.55,232.77,185.22,259.84Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.38,255.92a17.87,17.87,0,0,1-1.94.09,3.17,3.17,0,0,1-2-.29,1,1,0,0,1-.31-1.18,2.49,2.49,0,0,1,2.22-1.18,3.64,3.64,0,0,1,2.54.68A1.06,1.06,0,0,1,179.38,255.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.69,264.26c.64-.17,1.2-.44,1.82-.67a3.18,3.18,0,0,0,1.73-1,1,1,0,0,0-.19-1.2,2.46,2.46,0,0,0-2.5-.22,3.68,3.68,0,0,0-2.08,1.61A1.07,1.07,0,0,0,162.69,264.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.37,267c0-.07-.12.13-.1.2.58,1.83.94,4-.55,5.1-.05,0,0,.13.05.1C168.72,271.57,168.21,268.67,167.37,267Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.17,265.58c-3,.61-1.56,6.62,1.24,6.05S167.71,265.06,165.17,265.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.07,266.18c-.44.47-.81,1.19-1.43,1.41s-1.42-.25-2-.73c-.07-.06-.11,0-.09.09.26,1.15,1,2.23,2.27,2.1s1.72-1.33,1.73-2.56C164.51,266.26,164.25,266,164.07,266.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.69,263.7c0-.08.16.05.18.13.38,1.88,1.13,4,3,4.19.06,0,.07.1,0,.1C178.71,268.32,177.75,265.54,177.69,263.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.9,261.36c2.94-.93,4.59,5,1.86,5.89S176.43,262.14,178.9,261.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.25,261.41c.56.18,1.18.63,1.75.51s1-.92,1.22-1.65c0-.08.08,0,.11,0,.34,1.13.29,2.42-.74,2.94s-2-.3-2.53-1.36C180,261.7,180,261.33,180.25,261.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,280.94c.54.35,1.1.87,1.8.79a5.08,5.08,0,0,0,1.93-.86c.05,0,.12,0,.1.08a2.58,2.58,0,0,1-2.19,1.48,2,2,0,0,1-1.8-1.37C170.78,281,170.92,280.89,171,280.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,273.24s1.09,2.68,1.43,4c0,.13-4.49,2.33-7.39-.36a.14.14,0,0,1,.15-.23,9.62,9.62,0,0,0,6.09.18c0-.39-2-4.52-1.82-4.59a12,12,0,0,1,3.14-.09c-2.11-5.63-5.11-10.88-7.13-16.53a.18.18,0,0,1,.32-.17c3.53,5.28,6.11,11.72,8.44,17.48C180.5,273.63,177.56,273.33,177,273.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.52,236.67s1.8,4,.86,7.23c-1.91,6.68-9.64,6.31-11.77,9.18-2,2.69-.37,7.3-2.15,9.95-2.46,3.68-6.74,3.13-6.87,5.35s-.41,9.27-3,10.59-22.68-41.82,13.16-46.38c0,0,4.57-2.88,12.78-.28,9.5,3,15.47,16.46,15.47,16.46a12.43,12.43,0,0,0-2.06-1.53c-2-1.23-2.87-2.52-4.3-3.29-2.23-1.21-3.22-.44-5.53-1.6A23.66,23.66,0,0,1,162.52,236.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.65,234.8a23.87,23.87,0,0,1,1.95,5.27,10.1,10.1,0,0,1,.13,5.42,7.49,7.49,0,0,1-3.55,3.86c-1.59.91-3.43,1.4-5.13,2.44A5.56,5.56,0,0,0,153,254a7.42,7.42,0,0,0-.59,2.91c-.07,1.89-.15,3.75-1.15,5.26A6.27,6.27,0,0,1,146.8,265c-1.8.3-3.86.13-5.48,1.21,1.7-.95,3.64-.61,5.53-.78a6.81,6.81,0,0,0,5-2.86c1.22-1.65,1.28-3.77,1.39-5.59a6.73,6.73,0,0,1,.54-2.59,4.74,4.74,0,0,1,1.8-1.81c1.51-1,3.37-1.5,5.05-2.48a9.87,9.87,0,0,0,2.31-1.82,5.94,5.94,0,0,0,1.5-2.55A10.63,10.63,0,0,0,164,240,24.35,24.35,0,0,0,161.65,234.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.6,236.3a19.67,19.67,0,0,0,2.55,4.62,9.3,9.3,0,0,0,4.23,3.33,13.89,13.89,0,0,0,2.62.54,4.21,4.21,0,0,1,2.14,1,13.3,13.3,0,0,0,1.9,1.84,5.79,5.79,0,0,0,2.49.94,6.48,6.48,0,0,1-2.21-1.28,13,13,0,0,1-1.67-2,4.56,4.56,0,0,0-2.48-1.31,13.49,13.49,0,0,1-2.48-.56,9.71,9.71,0,0,1-4-2.94A38.29,38.29,0,0,1,162.6,236.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.09,271.2s-10.82-20.59.87-32.54c12.13-12.39,29-7.84,29-7.84s-18.38,1.15-26,11.12C130.13,253.53,135.09,271.2,135.09,271.2Z",
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.86,277.64a8.91,8.91,0,1,1,6.75-12.35h0A8.92,8.92,0,0,1,167,277,8.71,8.71,0,0,1,164.86,277.64Zm-2.66-16.42a7.72,7.72,0,1,0,8.31,4.55A7.73,7.73,0,0,0,162.2,261.22Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.5,271.94c-3.37.54-7-2.41-8.25-6.88a10.6,10.6,0,0,1,.1-6.51,5.55,5.55,0,0,1,9.14-2.6,10.66,10.66,0,0,1,3.52,5.47c1.34,4.73-.43,9.39-3.94,10.39C184.88,271.86,184.69,271.91,184.5,271.94ZM181,255.72a2.51,2.51,0,0,0-.44.1,4.73,4.73,0,0,0-3,3.14,9.5,9.5,0,0,0-.08,5.77c1.17,4.09,4.45,6.76,7.35,5.93s4.28-4.82,3.12-8.91a9.46,9.46,0,0,0-3.11-4.87A4.9,4.9,0,0,0,181,255.72Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.6,266.37l-1-.67c1-1.46,3.58-3.79,6.31-2.14l-.61,1C173.86,263.1,171.69,266.23,171.6,266.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5,279.77l-1.17-.24c.11-.54,1.15-5.35,3.59-6.5,2.28-1.06,19.6-4.32,20.27-4.44l.21,1.17c-4.52.83-18.21,3.53-20,4.35S132.77,278.45,132.5,279.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.15,274.8s-7.68-7.47-11.18-4.57,3.43,14.54,8.35,15.37a4.77,4.77,0,0,0,5.78-3.72Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,273.52a.07.07,0,0,0,0,.13c3.48.68,5.75,3.35,7.53,6.21-1.19-1-2.62-1.41-4,0-.07.08,0,.19.12.16a2.93,2.93,0,0,1,3.36.39,14,14,0,0,1,2,2.27c.21.26.7,0,.53-.31a.16.16,0,0,1,0-.07C141.82,278.22,137.52,273.09,133,273.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.41,311.63s19.4,13.91,30.49,12.47S165,311.93,165,311.93s-11.1-9.72-24.19-9.1C131.32,303.27,124.41,311.63,124.41,311.63Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "55.82 425.76 135.62 425.51 215.41 425.43 375 425.26 534.59 425.42 614.38 425.51 694.18 425.76 614.38 426 534.59 426.09 375 426.25 215.41 426.09 135.62 426 55.82 425.76",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Devices--inject-60"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.73,
    y: 423.24,
    width: 111.19,
    height: 4.99,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.73,
    y: 423.24,
    width: 55.97,
    height: 4.99,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.4 428.23 345.77 428.23 361.08 354.63 252.71 354.63 237.4 428.23",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.84,393.07a6.38,6.38,0,0,0,6.46,7.22,8.22,8.22,0,0,0,8-7.22,6.38,6.38,0,0,0-6.47-7.22A8.21,8.21,0,0,0,290.84,393.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.38,
    y: 423.24,
    width: 111.19,
    height: 4.99,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 509.61,
    y: 423.24,
    width: 55.97,
    height: 4.99,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "510.9 428.23 402.54 428.23 387.23 354.63 495.59 354.63 510.9 428.23",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.46,393.07a6.38,6.38,0,0,1-6.46,7.22,8.21,8.21,0,0,1-8-7.22,6.38,6.38,0,0,1,6.46-7.22A8.21,8.21,0,0,1,457.46,393.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.81,336.52c-9.68,0-17.26-20.31-17.26-46.24S486.13,244,495.81,244s17.26,20.31,17.26,46.24S505.49,336.52,495.81,336.52Zm0-89.48c-6.89,0-14.26,17.38-14.26,43.24s7.37,43.24,14.26,43.24,14.26-17.37,14.26-43.24S502.7,247,495.81,247Z",
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.86,318c-5.5,0-9.35-1.56-11.09-4.58-2.45-4.24-.34-10.61,5.93-17.93,5.94-6.93,15-14.08,25.48-20.13s21.21-10.32,30.18-12c9.48-1.77,16-.42,18.49,3.82s.34,10.61-5.93,17.93c-5.94,6.93-15,14.08-25.48,20.14s-21.21,10.31-30.18,12A40.39,40.39,0,0,1,466.86,318Zm58-52.41a38.49,38.49,0,0,0-6.94.72c-8.64,1.62-19,5.75-29.23,11.64s-19,12.82-24.7,19.49c-5.31,6.2-7.35,11.47-5.62,14.48s7.33,3.87,15.35,2.37c8.64-1.61,19-5.75,29.23-11.64s19-12.82,24.7-19.49c5.31-6.19,7.35-11.47,5.62-14.48C532.08,266.62,529.13,265.57,524.85,265.57Z",
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.76,318a40.48,40.48,0,0,1-7.4-.76c-9-1.68-19.69-5.94-30.18-12S467.64,292,461.7,285.09c-6.27-7.32-8.38-13.69-5.93-17.93s9-5.59,18.49-3.82c9,1.68,19.69,5.94,30.18,12s19.54,13.2,25.48,20.13c6.27,7.32,8.38,13.69,5.93,17.93C534.11,316.42,530.26,318,524.76,318Zm-58-52.41c-4.28,0-7.23,1.05-8.41,3.09-1.73,3,.31,8.29,5.62,14.48,5.72,6.67,14.5,13.6,24.7,19.49s20.59,10,29.23,11.64c8,1.5,13.61.64,15.35-2.37s-.31-8.28-5.62-14.48c-5.72-6.67-14.49-13.59-24.7-19.49s-20.59-10-29.23-11.64A38.49,38.49,0,0,0,466.77,265.57Z",
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.81,
    cy: 290.28,
    r: 6.79,
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.67 256.81 249.24 333.71 202.8 256.81 237.35 256.81 249.24 279.14 261.12 256.81 295.67 256.81",
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.86 256.81 249.24 305.59 220.61 256.81 237.35 256.81 249.24 279.14 261.12 256.81 277.86 256.81",
    style: {
      fill: "#000102",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.94 177.44 414.1 244.26 375 256.68 335.9 244.26 324.06 177.44 375 152.57 425.94 177.44",
    style: {
      fill: "#4BC46D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 251.36 375 157.89 420.68 180.19 410.07 240.12 375 251.36",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.52,177.86h9l20,52.53H389l-4.88-13.1H365.79L361,230.39H350.47Zm11.77,32.25L375,189.47l-7.55,20.64Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cursor--inject-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "416.16 261.52 420.55 272.13 416.17 273.94 411.75 263.26 404.5 268.89 404.5 239.01 425.42 260.14 416.16 261.52",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.5,235.76a4,4,0,0,1-.26-1.5,4,4,0,0,1,.26-1.51,4,4,0,0,1,.27,1.51A4,4,0,0,1,404.5,235.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.92,236.83a4.39,4.39,0,0,1-2.13-2.12,3.74,3.74,0,0,1,1.25.87A4,4,0,0,1,401.92,236.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.84,239.42a4.46,4.46,0,0,1-3,0,4.3,4.3,0,0,1,3,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.92,242a4.47,4.47,0,0,1-2.13,2.13,4.47,4.47,0,0,1,2.13-2.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.16,239.42a4,4,0,0,1,1.5-.27,4,4,0,0,1,1.51.27,4,4,0,0,1-1.51.26A4,4,0,0,1,408.16,239.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.09,236.83a4.17,4.17,0,0,1,.87-1.25,3.84,3.84,0,0,1,1.25-.87,3.84,3.84,0,0,1-.87,1.25A4.17,4.17,0,0,1,407.09,236.83Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavaScriptframeworksCuate);
export default __webpack_public_path__ + "static/media/JavaScript frameworks-cuate.dacff9ec3b04b31684780b3cbd88a5d6.svg";
export { ForwardRef as ReactComponent };